<script setup lang="ts">
import {Knowledgeable} from "@/knowledge-box/interfaces";
import InterviewShortCutContainer
    from "@/interview/components/instance-modal/short-cuts/InterviewShortCutContainer.vue";
import ProgramKnowledgeables from "@/program/components/program-knowledgeables/ProgramKnowledgeables.vue";

defineProps<{knowledgeables: Knowledgeable[]}>();
</script>

<template>
  <InterviewShortCutContainer>
    <div class="flex">
      <ProgramKnowledgeables :knowledgeables="knowledgeables" />
    </div>
  </InterviewShortCutContainer>
</template>

<style scoped>

</style>
